export const path = "/master/immediate";

export const handler = data => {
  return data.heroSlide
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/heroSlide.js